import { useQuery } from '@tanstack/react-query';
import createQueryRequest from 'services/createQueryRequest';
import useAPI from 'services/useAPI';

// general structure of the query keys that should probably work for most cases
export const groupKeys = {
  all: ['groups'],
  groups: () => [...groupKeys.all],
  group: (id) => [...groupKeys.groups(), id]
};


export const useGroupsQuery = () => {
  const api = useAPI();
  const groupsQuery = useQuery(groupKeys.groups(), createQueryRequest(api.core.getGroups));
  return groupsQuery;
};

export const useGroupQuery = (id) => {
  const api = useAPI();
  const groupQuery = useQuery(groupKeys.group(id), createQueryRequest(api.core.getGroup, id));
  return groupQuery;
};
